// components/onboarding/OwnerOnboarding.jsx
import React from 'react';
import { OnboardingProvider } from '../../context/OnboardingContext';
import OnboardingWelcomeModal from './OnboardingWelcomeModal';
import OnboardingOverlay from './OnboardingOverlay';
import OnboardingTooltip from './OnboardingTooltip';

/**
 * OwnerOnboarding
 *
 * Orchestrator component that wraps and renders all onboarding components
 * for the Owner role. Should be placed inside OwnerProvider but outside
 * the main layout components.
 */
const OwnerOnboarding = () => {
    return (
        <>
            {/* Welcome modal for first-time users */}
            <OnboardingWelcomeModal />

            {/* Overlay with spotlight effect */}
            <OnboardingOverlay />

            {/* Tooltip with step instructions */}
            <OnboardingTooltip />
        </>
    );
};

/**
 * OwnerOnboardingWrapper
 *
 * Wrapper that includes the OnboardingProvider context.
 * Use this when you need to wrap components with the provider.
 */
export const OwnerOnboardingWrapper = ({ children }) => {
    return (
        <OnboardingProvider>
            {children}
            <OwnerOnboarding />
        </OnboardingProvider>
    );
};

export default OwnerOnboarding;
